// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UserRoleEntityMapper from "../entity-mapper/UserRoleEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = UserRoleEntityMapper.execute;

var UserRoleResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var UserRoleResponseConverter = partial_arg(UserRoleResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  UserRoleResponseConverterConfig ,
  UserRoleResponseConverter ,
  
}
/* UserRoleResponseConverter Not a pure module */
